import React from 'react';
import styled from 'styled-components';
import { Typography, SxProps, Theme } from '@mui/material';
import { FlexColumn, Flex } from '../Flex';
import { fontSize } from '../../style/utils';

const ERROR_LINE_HEIGHT = '10px';
const DESCRIPTION_LINE_HEIGHT = '15px';

export const formFieldRequiredLabel = 'This field is required';

const FieldErrorMessage = styled(Typography)`
  color: ${({ theme }) => theme.palette.status.error.bright};
  font-size: ${fontSize('xxs')};
  line-height: ${ERROR_LINE_HEIGHT};
`;

const HelperText = styled(Typography)`
  color: ${({ theme }) => theme.palette.content.tertiary};
`;

const Description = styled(Typography)`
  font-size: ${fontSize('sm')};
  color: ${({ theme }) => theme.palette.content.secondary};
  line-height: ${DESCRIPTION_LINE_HEIGHT};
`;

const OptionalIndication = () => <HelperText>(optional)</HelperText>;

type FormFieldProps = {
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  children: React.ReactNode;
  errorMessage?: string;
  optional?: boolean;
  sx?: SxProps<Theme>;
};

const FormField = ({
  title,
  description,
  children,
  errorMessage,
  optional = false,
  sx,
}: FormFieldProps) => (
  <FlexColumn gap={1} sx={sx}>
    {title && (
      <Flex gap={1}>
        <Typography>{title}</Typography> {optional && <OptionalIndication />}
      </Flex>
    )}
    {description &&
      (typeof description === 'string' ? (
        <Description>{description}</Description>
      ) : (
        description
      ))}
    {children}
    {errorMessage && <FieldErrorMessage>{errorMessage}</FieldErrorMessage>}
  </FlexColumn>
);

export default FormField;
